import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Check if fbq already exists
    if ((window as any).fbq) return;
    // Meta Pixel Code - Modified for React
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    // Append to head
    document.head.appendChild(script);
    // Initialize fbq function
    const fbq = function () {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, arguments);
      } else {
        fbq.queue.push(arguments);
      }
    };
    (window as any).fbq = fbq;
    (window as any)._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    // Initialize pixel and track PageView
    script.onload = () => {
      ;
      (window as any).fbq('init', '777405255323572');
      (window as any).fbq('track', 'PageView');
    };
  }, []);
  return <noscript data-id="element-72">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=777405255323572&ev=PageView&noscript=1" alt="" data-id="element-73" />
    </noscript>;
}